import script from "./EventsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsHeader.vue?vue&type=script&setup=true&lang=js"

import "./EventsHeader.vue?vue&type=style&index=0&id=e22a176c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e22a176c"]])

export default __exports__